export const SQMM_PER_SQFT = 92903.04;

export const TYPOLOGIES = [
  "Fixed",
  "Casement",
  "Top Hung",
  "Bottom Hung",
  "Tilt & Turn",
  "2 Track Sliding",
  "3 Track Sliding",
  "4 Track Sliding",
  "Corner Sliding",
  "Sliding Door",
  "Lift & Slide Door",
  "Slide & Fold Door",
  "French Door",
  "Casement Door cum Window",
  "Fixed + Openable Combo",
  "Ventilator Louver Type",
];

export const GLASS_TYPES = [
  "6mm Clear TG Glass",
  "6mm Frosted TG Glass",
  "8mm Clear TG Glass",
  "DGU 6-12-6",
  "Louver Blade",
];

export function computeItem(item) {
  const w = Number(item.width_mm) || 0;
  const h = Number(item.height_mm) || 0;
  const nos = Number(item.nos) || 0;
  const rate = Number(item.rate) || 0;
  const margin = Number(item.margin_percent) || 0;
  const unitArea = w && h ? (w * h) / SQMM_PER_SQFT : 0;
  const qtySqft = Math.round(unitArea * nos * 100) / 100;
  const basic = qtySqft * rate;
  const amount = basic * (1 + margin / 100);
  return {
    unit_sqft: Math.round(unitArea * 100) / 100,
    qty_sqft: qtySqft,
    basic_amount: Math.round(basic * 100) / 100,
    amount: Math.round(amount * 100) / 100,
  };
}

export function computeTotals(items, globalMarginPercent, gstPercent) {
  const computed = items.map((i) => ({ ...i, ...computeItem(i) }));
  const basicSubtotal = computed.reduce((s, i) => s + i.basic_amount, 0);
  const subtotalAfterLine = computed.reduce((s, i) => s + i.amount, 0);
  const lineMarginTotal = subtotalAfterLine - basicSubtotal;
  const gm = Number(globalMarginPercent) || 0;
  const globalMarginAmount = (subtotalAfterLine * gm) / 100;
  const taxable = subtotalAfterLine + globalMarginAmount;
  const gst = Number(gstPercent) || 0;
  const gstAmount = (taxable * gst) / 100;
  const grandTotal = taxable + gstAmount;
  return {
    computed,
    basicSubtotal,
    lineMarginTotal,
    subtotalAfterLine,
    globalMarginPercent: gm,
    globalMarginAmount,
    taxable,
    gstPercent: gst,
    gstAmount,
    grandTotal,
    totalUnits: computed.reduce((s, i) => s + (Number(i.nos) || 0), 0),
    totalSqft: computed.reduce((s, i) => s + i.qty_sqft, 0),
  };
}

export function fmtMoney(n) {
  return (Number(n) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function fmtNum(n) {
  return (Number(n) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
